import { Injectable } from '@angular/core';
import { GenericService } from '@messaia/cdk';
import { Observable } from 'rxjs';
import { Contract } from '../models/contract';
import { ContractTermination } from '../models/contract-termination';

@Injectable({ providedIn: 'root' })
export class ContractService extends GenericService<Contract> {

	/**
	 * Constructor
	 */
	constructor() {
		super('contract');
	}

	/**
	 * Synchronizes an contract
	 * @param id The ID of the contract
	 */
	public updateStatus(id: number): Observable<any> {
		return this.update(`updateStatus/${id}`, null);
	}

	/**
	 * cancells an contract
	 * @param id The ID of the contract
	* @param contractTermination
	 */
	public cancel(id: number, contractTermination: ContractTermination): Observable<any> {
		return this.update(`cancel/${id}`, contractTermination);
	}

	/**
	 * Revokes cancellation of the specified contract
	 * @param id The ID of the contract
	 */
	public revokeCancellation(id: number): Observable<any> {
		return this.update(`revokeCancellation/${id}`, null);
	}
}